import { Component } from '@angular/core';
import { GridUtil } from 'src/app/components/grid/GridUtil';
import { IPassport, UploadCandidatePassportModel } from 'src/app/interface/dto';
import { CandidateService } from 'src/app/services/candidate-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-upload-candidates',
  templateUrl: './upload-candidates.component.html',
  styleUrls: ['./upload-candidates.component.scss']
})
export class UploadCandidatesComponent {
  uploadCand: IPassport = {
    examNo: '',
    file: undefined,
    imageUrl: ''
  }
  constructor(private snackBar: SnackbarService, private candidateService: CandidateService,) { }

  onFileChange(event: any) {

    if (event.target.files && event.target.files[0]) {
      this.uploadCand.file = event.target.files[0];
    }
  }
  async uploadCandidates() {
    let formData = new FormData();
    formData.append('file', this.uploadCand.file);
    await this.candidateService.uploadCandidate(formData).then(s => {
      this.snackBar.success('Candidates uploaded successfully');
      this.candidateService.setSelectedCandidate([]);
      GridUtil.getGridSelection()
      window.location.assign('/candidates');
    });
  }
}
